export interface IGenericResponse {
    success: boolean;
    errorsMessages: string[];
    data: any;
}

export interface IUser {
    UserId: string;
    UserName: string;
    CreateDate: string;
    LastActivityDate: string;
    Email: string;
    Password: string;
    IsApproved: boolean;
    IsLockedOut: boolean;
    Comment: string;
}

export class UserRequest {
    constructor(
        public UserId: string,
        public UserName: string,
        public Email: string,
        public Password: string,
        public ConcatenatedNameRoles: string,
        public Comment: string
    ) {}
}

export interface IAllUsers extends IGenericResponse {
    data: IUser[];
}

export interface IRol {
    RoleId: string;
    RoleName: string;
    Description: string;
    HasIt: number;
}

export class RoleUser {
    RoleId: string;
    RoleName: string;
    Description: string;
    HasIt: boolean;
    constructor(model: any) {
        this.RoleId = model.RoleId,
        this.RoleName = model.RoleName,
        this.Description = model.Description,
        this.HasIt = (model.HasIt === 1 ? true : false)
    }
}

export interface IRoles extends IGenericResponse {
    data: IRol[];
}